/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 10:44:12
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 13:12:19
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Invoice/Invoice.tsx
 */
import { Skeleton } from '@/src/components/Antd';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import {
  getInvoiceSetting,
  saveInvoiceSetting,
} from '@/src/request/settings/invoice';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { Form, message } from 'antd';
import _ from 'lodash';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import ModalHOC from 'src/constrains/ModalHOC';
import RouteBlock from 'src/constrains/RouterBlock/RouterBlock';
import AvailableInvoice from './AvailableInvoice';
import { breadcrumbData } from './config';
import css from './css.module.less';
import InvoiceFormat from './InvoiceFormat';
import InvoiceInformation from './InvoiceInformation';
import OtherInformation from './OtherInformation';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const permissions = () => {
  const view_invoice_details = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsInvoice,
        operation: EnumOperation.view_invoice_details,
      }),
    ],
  });
  const edit_setting_preview_test_invoice_print_test_invoice = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsInvoice,
        operation:
          EnumOperation.edit_setting_preview_test_invoice_print_test_invoice,
      }),
    ],
  });
  return {
    view_invoice_details,
    edit_setting_preview_test_invoice_print_test_invoice,
  };
};

const Invoice = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { modalOp } = props;
  const {
    view_invoice_details,
    edit_setting_preview_test_invoice_print_test_invoice,
  } = permissions();
  const [form] = Form.useForm();
  const history = useHistory();
  const [storeData, setStoreData] = useState({});
  const [information, setInformation] = useState([]);
  const [invoiceSetting, setInvoiceSetting] = useState({} as any);
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const { setShowModal, setModalTitle, setModalContent } = modalOp;

  useEffect(() => {
    if (view_invoice_details) {
      getInvoiceSetting().then((data) => {
        setStoreData(data.store);
        setInformation((data.invoiceSetting.information || {}).items || []);
        setInvoiceSetting(data.invoiceSetting || ({} as any));
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const goBackToList = () => {
    history.push({
      pathname: '/settings',
    });
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData({ getI18n })}
    />
  );

  const addInformation = (item) => {
    const informationCopy = _.cloneDeep(information);
    informationCopy.push(item);
    setInformation(informationCopy);
    setShowModal(false);
    setHasModified(true);
  };

  const editInformation = (record) => {
    const informationCopy = _.cloneDeep(information);
    setHasModified(true);
    setInformation(
      informationCopy.map((item) => (item.uuid == record.uuid ? record : item)),
    );
    setShowModal(false);
  };
  const deleteInformation = (record) => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('general.deletethisinformation')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => handleDelete(record)}
        okText={getI18n('general.delete')}
        errorText={getI18n('storeInvoice.detail.deleteOne')}
      />,
    );
  };

  const handleDelete = (record) => {
    const informationCopy = _.cloneDeep(information);
    const arrDelete = informationCopy.filter(
      ({ uuid }) => uuid !== record.uuid,
    );
    setInformation(arrDelete);
    setHasModified(true);
  };

  const topRight = (
    <TopRight
      onDiscard={goBackToList}
      onSubmit={() => {
        form.submit();
      }}
      onSaveDisable={!hasModified}
    />
  );

  const onFinish = (values) => {
    values['information'] = {};
    values['information']['items'] = information;
    saveInvoiceSetting(values).then(() => {
      message.success(getI18n('general.savesuccess'));
      setHasModified(false);
    });
  };

  const Child = [
    {
      child: (
        <AvailableInvoice
          form={form}
          disabled={!view_invoice_details}
          disableEdit={!edit_setting_preview_test_invoice_print_test_invoice}
        />
      ),
    },
    {
      child: (
        <InvoiceInformation
          storeData={storeData}
          disabled={!view_invoice_details}
          disableEdit={!edit_setting_preview_test_invoice_print_test_invoice}
        />
      ),
    },
    {
      child: (
        <InvoiceFormat
          disabled={!view_invoice_details}
          disableEdit={!edit_setting_preview_test_invoice_print_test_invoice}
        />
      ),
    },
    {
      child: (
        <OtherInformation
          information={information}
          setShowModal={setShowModal}
          setModalTitle={setModalTitle}
          setModalContent={setModalContent}
          addInformation={addInformation}
          editInformation={editInformation}
          deleteInformation={deleteInformation}
          disabled={!view_invoice_details}
          disableAdd={!edit_setting_preview_test_invoice_print_test_invoice}
        />
      ),
    },
  ];

  return (
    <Fragment>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.commonHeader.leave_text')}
        active={hasModified}
        title={getI18n('general.commonHeader.leave_header')}
        content={getI18n('general.commonHeader.leave_content')}
      />
      <Skeleton loading={loading} active>
        <Form
          className={css.invoiceContainerForm}
          name='invoice'
          form={form}
          onFinish={onFinish}
          onValuesChange={() => {
            setHasModified(true);
          }}
          initialValues={{
            ...invoiceSetting,
            downloadable: invoiceSetting.downloadable || true,
            downloadSize: invoiceSetting.downloadSize || 'A4',
            printable: invoiceSetting.printable || true,
            printSize: invoiceSetting.printSize || 'A4',
          }}>
          <Layout
            elements={Child}
            topLeft={topLeft}
            topRight={topRight}></Layout>
        </Form>
      </Skeleton>
    </Fragment>
  );
};

export default ModalHOC(Invoice);
{
}
